import { Comment, Text, Fragment, type Slot, type VNode } from 'vue';
import './Array';

export function hasSlotContent(slot: Slot | undefined | null, props: any = {}) {
  return (! isSlotEmpty(slot, props));
}

export function isSlotEmpty(slot: Slot | undefined | null, props: any = {}) {
  return isVNodeEmpty(slot?.(props));
}

export function isVNodeEmpty(vnode: VNode | VNode[] | undefined | null) {
  return (
    (! vnode) ||
    Array.asArray(vnode).every(
      (vnode) =>
        (vnode.type === Comment) ||
        ((vnode.type === Text) && !vnode.children?.length) ||
        ((vnode.type === Fragment) && !vnode.children?.length),
    )
  );
}
